/* eslint-disable no-new-object */
import React from "react";
import axios from 'axios'
import $ from 'jquery';
import {utils,writeFileXLSX} from 'xlsx';

export function getWindowSize() {
  const {innerWidth, innerHeight} = window;
  return {innerWidth, innerHeight};
}
export function isNull(sopt) {
  if(sopt === undefined || sopt === null || sopt === "" || sopt === 'null') return true;
  return false;
}
export function isNullNumber(sopt) {
  if(sopt === undefined || sopt === null || sopt === "" || sopt === 0) return true;
  return false;
}
export function isNullTime(sopt) {
  if(sopt === undefined || sopt === null || sopt === "" || sopt.sub(0,5) === "00:00") return true;
  return false;
}
//값이 없으면
export const IfNotNull= (input)=>{
  if (input !== null && input !== undefined && input !== '') {
    return true;
  };
  return false;
}
//날짜문자가 Null이면 오늘 날짜 반환
export const GetDateAfterCheckNull = (sdate) => {
  if(isNull(sdate)) {
    const ndate = new Date();
    let year = ndate?.getFullYear();
    let month = ('0' + (ndate?.getMonth() + 1)).slice(-2);
    let day = ('0' + ndate?.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  } else {
    return sdate;
  }
}
//객체가 비어 있는지 확인
export function isObjEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
}
export function AddZeroFillForNumber(inumb,ileng)  {
  let snumb = inumb.toString();
  let inumbleng = snumb.length;
  let addleng = ileng - inumbleng;
  if(addleng <= 0) return snumb;
  for(var i=0; i < addleng; i++) {
    snumb = '0' + snumb;
  }
  return snumb;
}
//날짜계산
export function SetDateFromDate(smode,ibetValue) {
  let ndate = new Date();
  if(smode === 'y') {
    return new Date(ndate.setFullYear(ndate.getFullYear() + ibetValue));
  } else if(smode === 'm') {
    return new Date(ndate.setMonth(ndate.getMonth() + ibetValue));
  } else {
    return new Date(ndate.setDate(ndate.getDate() + ibetValue));
  }
}
//날짜 30일 더하기
export function GetExpiredDateAfterThirtyDays(sdate) {
  let ndate = new Date(sdate);
  let afterDate = new Date(ndate.setDate(ndate.getDate() + 30));
  const year = afterDate.getFullYear();
  const month = ('0' + (afterDate.getMonth() + 1)).slice(-2);
  const day = ('0' + afterDate.getDate()).slice(-2);
  return year + '.' + month + '.' + day;
}
export function GetCurrentMonth() {
  const today = new Date();
  let year = today?.getFullYear();
  let month = ('0' + (today?.getMonth() + 1)).slice(-2);
  return year + '-' + month;
}
export function GetYearMonth(ndate,sdiv) {
  let year = ndate?.getFullYear();
  let month = ('0' + (ndate?.getMonth() + 1)).slice(-2);
  return year + sdiv + month;
}
export function ChangeShowMonth(smonth,ino) {
  let sdate = new Date(smonth+'-01');
  sdate.setMonth(sdate.getMonth()+ino);
  let year = sdate?.getFullYear();
  let month = ('0' + (sdate?.getMonth() + 1)).slice(-2);
  return year + '-' + month;
}
export function ChangeSearchingDateFormat(sdate,sdiv) {
  let ndate = "";
  //console.log(sdate);
  if (isNull(sdate)) {
    ndate = null;
  } else {
    let year = sdate?.getFullYear();
    let month = ('0' + (sdate?.getMonth() + 1)).slice(-2);
    let day = ('0' + sdate?.getDate()).slice(-2);
    ndate = year + sdiv + month + sdiv + day;
  }
  return ndate
}
export function GetDateFromJDate(jdate) {
  let ndate = null;
  if(isNull(jdate)) ndate = new Date();
  else ndate = new Date(jdate);

  let year = ndate.getFullYear();
  let month = ('0' + (ndate.getMonth() + 1)).slice(-2);
  let day = ('0' + ndate.getDate()).slice(-2);
  
  return year + '-' + month + '-' + day  ;
}
export function GetDateWeeksString(sdate) {
  if(isNull(sdate)) return "";
  const ndate = new Date(sdate);
  const weeks = GetWeekendDay(ndate);

  let year = ndate.getFullYear();
  let month = ('0' + (ndate.getMonth() + 1)).slice(-2);
  let day = ('0' + ndate.getDate()).slice(-2);

  return year + '. ' + month + '. ' + day + '(' + weeks + ')';
}
export function GetDateTimeFromJDateTime(jdatetime) {
  let ndate = null;
  if(isNull(jdatetime)) ndate = new Date();
  else ndate = new Date(jdatetime);

  let year = ndate.getFullYear();
  let month = ('0' + (ndate.getMonth() + 1)).slice(-2);
  let day = ('0' + ndate.getDate()).slice(-2);
  let hours = ('0' + ndate.getHours()).slice(-2);
  let minutes = ('0' + ndate.getMinutes()).slice(-2);
  let seconds = ('0' + ndate.getSeconds()).slice(-2);

  return year + '-' + month + '-' + day+ ' ' + hours + ':' + minutes+ ':' + seconds;
}
export function GetSimpleDateTimeFromJDateTime(jdatetime) {
  let ndate = null;
  if(isNull(jdatetime)) ndate = new Date();
  else ndate = new Date(jdatetime);

  let year = ndate.getFullYear().toString().substr(2);
  let month = ('0' + (ndate.getMonth() + 1)).slice(-2);
  let day = ('0' + ndate.getDate()).slice(-2);
  let hours = ('0' + ndate.getHours()).slice(-2);
  let minutes = ('0' + ndate.getMinutes()).slice(-2);
  let seconds = ('0' + ndate.getSeconds()).slice(-2);

  return year + '-' + month + '-' + day+ ' ' + hours + ':' + minutes+ ':' + seconds;
}
export function ChangeChattingDate(sdbdate) {
  let sdate = null;
  if (sdbdate === undefined || sdbdate === null || sdbdate === '') sdate = new Date();
  else{
    if(sdbdate.indexOf(' ') > 0) {
      sdbdate = sdbdate.replace(' ','T');
    }
    sdate = new Date(sdbdate);
  } 

  let year = sdate.getFullYear();
  let month = ('0' + (sdate.getMonth() + 1)).slice(-2);
  let day = ('0' + sdate.getDate()).slice(-2);

  let hours = ('0' + sdate.getHours()).slice(-2);
  let minutes = ('0' + sdate.getMinutes()).slice(-2);
  let seconds = ('0' + sdate.getSeconds()).slice(-2);

  const ndate = year + '.' + month + '.' + day + ' ' + hours + ':' + minutes+ ':' + seconds;
  return ndate
}
export function ChangeDateFormat(sdate) {
  if (isNull(sdate)) sdate = new Date();
  let year = sdate?.getFullYear();
  let month = ('0' + (sdate?.getMonth() + 1)).slice(-2);
  let day = ('0' + sdate?.getDate()).slice(-2);
  const ndate = year + '-' + month + '-' + day;
  return ndate
}
export function exceptTimeFromDate(sdate) {
  if (isNull(sdate)) return "";
  return sdate.substr(0,10);
}
export function ChangeDateFormatToKorean(sdate) {
  if (isNull(sdate)) sdate = new Date();
  let year = sdate.getFullYear();
  let month = sdate.getMonth() + 1;
  let day = sdate.getDate();
  const ndate = year + '년 ' + month + ' 월 ' + day + ' 일';
  return ndate
}
export function GetSalesMonthString(sdate,imode) {
  let ndate = new Date();
  if (!isNull(sdate)) ndate = new Date(sdate);
  let year = ndate.getFullYear();
  if(imode === 1) year = year.toString().substr(2,2);
  let month = ndate.getMonth() + 1;
  let rdate = year + '년 ';
  if(month > 0) rdate += month + ' 월 ';
  return rdate
}
export function GetShotDateString(sdate) {
  let ndate = new Date();
  if (!isNull(sdate)) ndate = new Date(sdate);

  let year = ndate.getFullYear();
  let syear = year.toString().substr(2,2);
  let smonth = ('0' + (ndate.getMonth() + 1)).slice(-2);
  let sday = ('0' + ndate.getDate()).slice(-2);

  return syear + '.' + smonth + '.' + sday ; 
}
export function GetMonthDateString(sdate) {
  let ndate = new Date();
  if (!isNull(sdate)) ndate = new Date(sdate);

  let smonth = ('0' + (ndate.getMonth() + 1)).slice(-2);
  let sday = ('0' + ndate.getDate()).slice(-2);

  return smonth + '.' + sday ; 
}
export function ChangeDateTimeFormat(odate) {
  let sdate = null;
  if (odate ===undefined || odate === null || odate === '') sdate = new Date();
  else{
    if(odate.indexOf(' ') > 0) {
      odate = odate.replace(' ','T');
    }
    sdate = new Date(odate);
  } 

  let year = sdate.getFullYear();
  let month = ('0' + (sdate.getMonth() + 1)).slice(-2);
  let day = ('0' + sdate.getDate()).slice(-2);

  let hours = ('0' + sdate.getHours()).slice(-2);
  let minutes = ('0' + sdate.getMinutes()).slice(-2);
  let seconds = ('0' + sdate.getSeconds()).slice(-2);

  const ndate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return ndate
}
export function ChangeDateMonth(sdate, imode = 0) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    let sdateString = sdate.substr(0, 7);
    if (imode === 1) sdateString = sdateString.replace(/-/g, '.');
    return sdateString;
  }
}
export function ChangeDateString(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    return sdate.replace(/-/g, '.');
  }
}
export function ChangeSimpleDateString(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "-";
  } else {
    sdate = sdate.substr(0,10);
    sdate = sdate.replace(/-/g, '.');
    return sdate.substr(2);
  }
}
export function GetSimpleYearMonth(sdate,sdiv) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    sdate = sdate.substr(0,7);
    sdate = sdate.replace(/-/g, sdiv);
    return sdate;
  }
}
export function ChangeDateStringOnlyDate(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    sdate = sdate.substr(0,10);
    return sdate.replace(/-/g, '.');
  }
}
export function ChangeTimeOnly(stime) {
  if (stime === null || stime === undefined || stime === "") {
    return "";
  } else {
    stime = stime.substr(0,5);
    return stime;
  }
}

export function ChangeDateStringToKorean(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    if(sdate.indexOf(' ') > 0) {
      const datetimeArray = sdate.split(' ');
      sdate = datetimeArray[0];
    }
    const dateArray = sdate.split('-');
    const ndate = dateArray[0] + '년 ' + Number(dateArray[1]) + ' 월 ' + Number(dateArray[2]) + ' 일';
    return ndate
  }
}
export function ChangeDateTimeString(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    const dateArray = sdate.split(' ');
    return dateArray[0].replace(/-/g, '.') + " " + dateArray[1];
  }
}

export function CheckToday(bdate) {
  const cDate = new Date();

  const sdate = new Date(bdate);

  const cyear = cDate.getFullYear();
  const cmonth = cDate.getMonth();
  const cday = cDate.getDate();

  const syear = sdate.getFullYear();
  const smonth = sdate.getMonth();
  const sday = sdate.getDate();

  if(cyear===syear && cmonth===smonth && cday===sday) return true;
  else return false;
}

//검색기간
export function MakeTerms(sdate) {
  if(sdate === undefined || sdate === null || sdate === "") sdate = new Date();
  const cyear = sdate.getFullYear();
  const cmonth = sdate.getMonth()+1; 
  const cdate = sdate.getDate();
  const firstDay = new Date(sdate.setDate(1)).getDay(); //첫번쨰 일자의 요일 : 6=토요일,0:일요일
  const cweek = Math.ceil((cdate+firstDay)/7); 
  return {years:cyear,months:cmonth,weeks:cweek};
}
//해당월에 주의 수
export function GetWeeks(iyear,imonth) {
  const monthFirstDate = new Date(iyear, imonth-1, 1);
  const monthLastDate = new Date(iyear, imonth, 0);

  //첫번쨰 일자의 요일 : 6=토요일,0:일요일
  const weekfirstday = monthFirstDate.getDay();
  const sfdate = monthFirstDate.getDate();  //1
  const sedate = monthLastDate.getDate();   //31 (7)
  
  let iweeks = 1;
  let bdate = sfdate; //첫번쨰 일요일에 해당하는 일자
  if(weekfirstday > 0) {
    iweeks++;
    bdate = sfdate + (7 - weekfirstday);
  }
  do { 
    bdate = bdate + 7;
    if(bdate < sedate) {
      iweeks++;
    } else if(bdate === sedate) {
      iweeks++; break;
    } else {
      break;
    }
  } while (true);
  return iweeks;
}
//해당월의 ?번쨰 주의 사직일(일요일)날짜 구하기
export function GetSearchDatesOfWeek(weekObj) {
  const monthFirstDate = new Date(weekObj.years, weekObj.months-1, 1);
  const monthLastDate = new Date(weekObj.years, weekObj.months, 0);
  console.log(weekObj);
  //첫째날 요일
  const weekfirstday = monthFirstDate.getDay();
  //마지막 날짜
  const maxDate = monthLastDate.getDate();

  //첫번쪠 일요일 일자
  let firstSunday = 1;
  let fwdate = 1, ewdate = 7;
  if(weekfirstday > 0) {  //월요일이후부터 시작
    firstSunday = 1 + (7 - weekfirstday);
    if(weekObj.weeks === 1) {
      fwdate = 1; ewdate = firstSunday - 1;
    } else {
      //주간 첫째날과 마지막날
      fwdate = firstSunday + (weekObj.weeks-2) * 7;
      ewdate = fwdate + 6;
      if(ewdate > maxDate) ewdate = maxDate;
    }
  }
  const sdate = ChangeDateFormat(new Date(weekObj.years, weekObj.months-1,fwdate));
  const edate = ChangeDateFormat(new Date(weekObj.years, weekObj.months-1,ewdate));
  console.log(sdate,edate);
  return {sdate:sdate,edate:edate};
}
//주건 널짜 잡기
export function GetDateArray(sObj) {
  console.log(sObj);
  const sdate = new Date(sObj.sdate);
  const weekday = sdate.getDay();

  let dateArray = [];
  const firstDay = sdate;
  firstDay.setDate(firstDay.getDate() - weekday);
  dateArray.push(ChangeDateFormat(firstDay));
  for(var i=1; i < 7; i++) {
    firstDay.setDate(firstDay.getDate()+1);
    dateArray.push(ChangeDateFormat(firstDay));
  }
  return dateArray;
}
//이번주 잡기
export function GetDateArrayForThisWeek() {
  const sdate = new Date();
  const weekday = sdate.getDay();

  let dateArray = [];
  const firstDay = sdate;
  firstDay.setDate(firstDay.getDate() - weekday);
  dateArray.push(ChangeDateFormat(firstDay));
  for(var i=1; i < 7; i++) {
    firstDay.setDate(firstDay.getDate()+1);
    dateArray.push(ChangeDateFormat(firstDay));
  }
  return dateArray;
}
//날짜별 숫자 반환
export function GetCountings(calendar,cladate) {
  const filterData = calendar.filter(el=>el.dates===cladate);
  if(filterData?.length > 0) {
    return filterData[0].tcount;
  } else {
    return 0;
  }
}
export function remainDays(expdate) {
  if (expdate === undefined || expdate === null || expdate === "" || expdate === 0) return -1;
  if (expdate.indexOf(' ') > 0) {
    var expdate_temp = expdate.split(' ');
    expdate = expdate_temp[0];
  }
  const dday = new Date(expdate);
  const today = new Date();

  const gap = dday.getTime() - today.getTime();
  let remaindays = Math.ceil(gap / (1000 * 60 * 60 * 24));
  return remaindays;
}

//생후 개월수
export function PassedMonths(birthday) {
  if (birthday === undefined || birthday === null || birthday === "" || birthday === 0) return 0;
  const dday = new Date(birthday);
  const today = new Date();

  const gap = today.getTime() - dday.getTime() ;
  let remainMonths = Math.ceil(gap / (1000 * 60 * 60 * 24 * 30));
  return remainMonths;
}
export function PassedMonthsCode(birthday) {
  if (birthday === undefined || birthday === null || birthday === "" || birthday === 0) return 0;
  const dday = new Date(birthday);
  const today = new Date();

  const gap = today.getTime() - dday.getTime() ;
  let remainMonths = Math.ceil(gap / (1000 * 60 * 60 * 24 * 30));
  if(remainMonths < 10) remainMonths = '0' + remainMonths;
  return 'M'+remainMonths;
}

//나이계산 - 생일기준
export function CalculateAge(sdate) {
  if(isNull(sdate) || sdate.length !== 8) return 0;
  const syear = sdate.substr(0,4);
  const smonth = sdate.substr(4,2);
  const sday = sdate.substr(6,2);

  const birthDate = new Date(syear+'-'+smonth+'-'+sday);
  var birthYear = birthDate.getFullYear();
  var birthMonth = birthDate.getMonth();
  var birthDay = birthDate.getDate();

  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();
  var currentMonth = currentDate.getMonth();
  var currentDay = currentDate.getDate();

  var age = currentYear - birthYear;
  if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) age--;
  return age;
}

//1000단위 실시간 점검
export function realThousandPoint(snum) {
  if (snum === undefined || snum === null || snum === "") return 0;
  var snum2 = snum.toString().replace(/[^\d]+/g, "");
  return parseInt(snum2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
//천단위 콤마찍기-- 소숫점
export function addThousandFloat(snum,idec=1) {
  if (snum === undefined || snum === null || snum === "" || snum === 0) return 0;
  let sarray = [];
  let snumb2 ='00000';
  if(snum.toString().indexOf('.') > 0) {
    sarray = snum.toString().split('.');
    snum = sarray[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    snumb2 = sarray[1] + '0000';
  }
  return snum + '.' + snumb2.substr(0,idec);
}
//줄바꿈
export const ChangeLines = (stext) => {
  if(isNull(stext)) return "";
  return stext.replace(/\|/g,"\n");
}
//천단위 콤마지우기
export function removeThousandFloat(snum) {
  return snum.replace(/,/g, "");
}
//천단위 콤마찍기--
export function addThousandPoint(snum) {
  if (snum === undefined || snum === null || snum === "") return 0;
  return parseInt(snum).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
//천단위 콤마지우기
export function removeThousandPoint(snum) {
  return snum.replace(/[^\d]+/g, "");
}
//한글제외
export function isExceptKoreanString(asValue) {
  if(asValue === undefined || asValue === null || asValue === "") return ""; 
  var regex = /[^0-9a-zA-Z@.]/g;
  var returnString = asValue.replace(regex, "");
  return returnString;
}
//전화번호에 - 넣기
export function ChangeMobileFormat(mbNumber) {
  if (mbNumber === undefined || mbNumber === "" || mbNumber === null) return "";
  //if(mbNumber.length === 8 && onlyNumber(mbNumber)) return mbNumber.substr(0,4)+'-'+mbNumber.substr(4,4);
  //return mbNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
  return mbNumber.replace(/[^0-9]/g, '').replace(/(^02|^0504|^0505|^0\d{2})(\d+)?(\d{4})$/, '$1-$2-$3');
}
export function ChangeMobileNumber(mbNumber) {
  if (mbNumber === undefined || mbNumber === "" || mbNumber === null) return "";
  return mbNumber.replace(/[^0-9]/g, '');
}
export function ChangeInternationalMobileNumber(mbNumber) {
  if (mbNumber === undefined || mbNumber === "" || mbNumber === null) return "";
  const ipos = mbNumber.indexOf(' ');
  const mobileNumber = '0' + mbNumber.substr(ipos+1, mbNumber.length - ipos);
  return ChangeMobileNumber(mobileNumber);
}
export function RemakeAddress(saddr) {
  if (saddr === undefined || saddr === "" || saddr === null) return "";
  const addrArray = saddr.split(' ');
  return addrArray[0]+' '+addrArray[1];
}

//아이디 문자열 점검
//2022-08-17 고객사 요청으로 숫자조합 제거 - KSR
export function checkIDString(asValue) {
  //var regExp = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z]{6,25}$/; //  6자 이상 영문 + 숫자 조합
  var regExp = /^[a-z|A-Z|0-9|]{6,25}$/; //영문,숫자 6자 이상
  if (!regExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//2022-08-17 고객사 요청으로 닉네임은 한글도 포함 - KSR 추가
export function checkNickString(asValue) {
  var regExp = /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|]{3,25}$/; //영문,한글,숫자 6자 이상
  if (!regExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//숫자만 입력
export function isOnlyNumber(asValue) {
  if(asValue === undefined || asValue === null || asValue === "") return ""; 
  var regex = /[^0-9]/g;
  var returnString = asValue.replace(regex, "");
  return returnString;
}

//전화번호 검색
export function isPhone(asValue) {
  var regExp = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/;
  var regExp2 = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;
  if (regExp.test(asValue)) {
    return regExp.test(asValue);
  } else if (regExp2.test(asValue)) {
    return regExp2.test(asValue);
  }
};
//이메일 문자열 점검
export function checkEmailString(eString) {
  if(eString === undefined || eString === null || eString === "") return false;
  var regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
  if (eString.match(regExp) != null) return true;
  else return false;
}
//비밀번호 형식 검사
export function isPassword(asValue) {
  var regExp = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/; //  8 ~ 16자 영문, 숫자, 특수문자 조합
  if (!regExp.test(asValue)) {
    return false;
  }
  return regExp.test(asValue) // 형식에 맞는 경우 true 리턴
}
//숫자 체크 정규식
export function onlyNumber(str) {
  return str.replace(/[^0-9.]/g, "").replace(/(\.*)\./g, "$1");
}
//숫자 체크 정규식
export function onlyBankAccountNumber(str) {
  return str.replace(/[^0-9-]/g, "").replace(/(\.*)\./g, "$1");
}
//사업자등록번호
export function checkCorporateRegiNumber(number){
  number = number.replace(/\s/gi, "");
	var numberMap = number.replace(/-/gi, '').split('').map(function (d){
		return parseInt(d, 10);
	});
  console.log("numberMap")
  console.log(numberMap)

	if(numberMap.length === 10){
		var keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
		var chk = 0;

		keyArr.forEach(function(d, i){
			chk += d * numberMap[i];
		});

		chk += parseInt((keyArr[8] * numberMap[8])/ 10, 10);
		console.log(chk);
		return Math.floor(numberMap[9]) === ( (10 - (chk % 10) ) % 10);
	}

	return false;
}

//사업자등록번호
export function isTax(asValue) {
  //var regExp = /^(?=.*[-])(?=.*[0-9]).{8,16}$/;
  var regExp = /^(\d{3,3})+[-]+(\d{2,2})+[-]+(\d{5,5})$/;


  /* regExp.test("asValue")
  console.log(asValue)
  console.log(regExp.test(asValue)) */
  if (regExp.test(asValue)) {
    return regExp.test(asValue);
  } else {
    return false;
  }
} 


export function resetCareerFromMonths(smonths) {
  if (smonths === undefined || smonths === "" || smonths === null) return "없음";
  if (smonths === 0) {
    return "없음";
  } else {
    const years = Math.floor(smonths / 12);
    const months = smonths % 12;
    var sterms = '';
    if (years > 0) {
      sterms = years + " 년";
    }
    if (months > 0) {
      if (sterms !== "") sterms += " ";
      sterms += months + " 개월";
    }
    return sterms
  }
}
export function CalculateCareerBetweenMonths(edate, sdate) {
  if (sdate === undefined || sdate === "" || sdate === null) {
    sdate = ChangeDateFormat('');
  };
  if (edate === undefined || edate === "" || edate === null) {
    edate = ChangeDateFormat('');
  };

  const expArray1 = sdate.split('-');
  if(expArray1.length === 2) expArray1[2] = '01';
  const startday = new Date(Number(expArray1[0]), Number(expArray1[1] - 1), Number(expArray1[2]));
  const expArray2 = edate.split('-');
  if(expArray2.length === 2) expArray2[2] = '01';
  const endday = new Date(Number(expArray2[0]), Number(expArray2[1] - 1), Number(expArray2[2]));
  var months;
  months = (endday.getFullYear() - startday.getFullYear()) * 12;
  months -= startday.getMonth();
  months += endday.getMonth();
  if (months < 0) months = 0;
  return Number(months);
}

//주민등록번호 마킹
export function MaskingCivilCode(scode) {
  console.log(scode);
  if (scode === undefined || scode === null || scode === "") {
    return "";
  }
  var ninArray = scode.split('-');
  var retString = ninArray[0] + '-' + ninArray[1].replace(/([0-9]{6})$/gi, "******");
  return retString;
}
//이메일 마킹
export function MaskingEmail(scode) {
  if (scode === undefined || scode === null || scode === "") {
    return "";
  }
  var ninArray = scode.split('@');
  const ileng = ninArray[0].length;
  let newString = ninArray[0];
  if(ileng > 3) {
    console.log(ninArray[0]);
    newString = ninArray[0].substr(0,ileng-3)+'***';
  }
  var retString = newString + '@' + ninArray[1]
  return retString;
}
//이름 마킹
export function MaskingName(sname) {
  if (sname === undefined || sname === null || sname === "") {
    return "";
  }
  let retString = sname;
  if(sname?.length === 2) retString = sname.substr(0,1)+"*";
  else if(sname?.length === 3) retString = sname.substr(0,1)+"*"+sname.substr(2,1);
  else retString = sname.substr(0,1)+"*"+sname.substr(2);
  return retString;
}
//문자열 마킹
export function MaskingString(sString,ist,showString) {
  if (sString === undefined || sString === null || sString === "") {
    return "";
  }
  let newString = "";
  let ileng = sString.length;
  if(ist > 0) {
    newString = sString.substr(0,ist);
  }
  //ileng = ileng - ist;
  for(var i=ist; i < ileng; i++) {
    newString += showString;
  }
  return newString;
}


//첨부파일 확장자 체크
export function checkFileName(str) {
  if(isNull(str)) return false;
  var ext = str.split('.');
  var ext1 = "." + ext[1].toLowerCase();
  var reg = /(.*?)\.(xlsx|docx|pdf|zip|hwp|ppt)$/;

  if (ext1.match(reg)) {
    return true;
  } else {
    return false;
  }
}

//주문코드생성
export function getPaymentCode() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
  const today = new Date();
  const year = today.getFullYear();
  const month = ('0' + (today.getMonth() + 1)).slice(-2);
  const day = ('0' + today.getDate()).slice(-2);
  let randomstring = 'PC'+month+day+year;
  for (let i = 0; i < 6; i++) {
    const rnum = Math.floor(Math.random() * chars.length)
    randomstring += chars.substring(rnum, rnum + 1)
  }
  return randomstring;
}

//코드생성 - 랜덤함수
export function randomString(stringLength) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';

  let randomstring = ''
  for (let i = 0; i < stringLength; i++) {
    const rnum = Math.floor(Math.random() * chars.length)
    randomstring += chars.substring(rnum, rnum + 1)
  }
  return randomstring;
}
//코드생성 - 숫자만 - 랜덤함수
export function randomStringOnlyNumber(stringLength) {
  const chars = '0123456789';

  let randomstring = ''
  for (let i = 0; i < stringLength; i++) {
    const rnum = Math.floor(Math.random() * chars.length)
    randomstring += chars.substring(rnum, rnum + 1)
  }
  return randomstring;
}

export function ChangeDate(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    const dateArray = sdate.split(' ');
    return dateArray[0];
  }
}

export const resetNavMenu = (imenu) => {
  //console.log(imenu);
  let navBlock = document.querySelector('.nav');
  let navItems = navBlock.querySelectorAll('.depth1');
  //console.log(navItems)
  for(var i=0; i < navItems.length; i++) {
    if(navItems[i].classList.contains('active')) {
      navItems[i].classList.remove('active');
    }
  }
  navItems[imenu].classList.add('active');
}

export const resetNavSubMenu = (main_idx, sub_idx) => {
  let navBlock = document.querySelector('.nav');
  let navItems = navBlock.querySelectorAll('.depth2 > li');
  //console.log(navItems)
  for(var i=0; i < navItems.length; i++) {
    if(navItems[i].classList.contains('active')) {
      navItems[i].classList.remove('active');
    }
  }
  if(sub_idx < 0) {
    return;
  }
  const depth1Boxes = document.querySelectorAll('.depth1');
  const depth2Boxes = depth1Boxes[main_idx].querySelector('.depth2');
  const liBoxes = depth2Boxes.querySelectorAll('li');
//   console.log(liBoxes)
  if(!liBoxes[sub_idx].classList.contains('active')) {
    liBoxes[sub_idx].classList.add('active');
  }
}

//화면조정
export const mobileWrap = () => {
  if (window.innerWidth < 890) {
    let tr = $(".tr");
    if (!tr.children().hasClass("m_wrap")) {
      tr.wrapInner("<div className='m_wrap'>");
      for(var i = 0; i < tr.length; i++) {
        let mWrap = $(tr[i]).children(".m_wrap");
        mWrap.after($(mWrap).children(".row_btn"));
      }
    }
  } else {
    let mWrap = $(".m_wrap");
    mWrap.children().unwrap();
  }
}

export const mobileWrapSearchTalent=()=>{
  if (window.innerWidth < 1024) {
    let tr = document.querySelectorAll(".tr");
    if (!$(tr).children().hasClass("m_colgroup")) {
      for(var i = 0; i < tr.length; i++) {
        $(tr[i]).find(".m_group").wrapAll("<div className='m_colgroup group1'></div>");
        $(tr[i]).find(".row_sort").wrapAll("<div className='m_colgroup group2'></div>");
      }
    }
  } else {
    $(".m_colgroup").children().unwrap();
  }
}

export const addDateDBFormat = (sdate,adddays) => {
  let fdate = new Date();
  if(sdate !== null && sdate !== "" && sdate !== "null") {
    fdate = new Date(sdate);
  }
  if(adddays === 0) return sdate;
  fdate.setDate(fdate.getDate() + adddays);
  return ChangeDateFormat(fdate);
}

//문자열에 공백이 있는 경우
export function blank_pattern (asValue) {
  let blankStr = /[\s]/g;
  if (blankStr.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//문자열에 특수문자가 있는 경우
export function special_pattern (asValue) {
  let specialStr = /[`~!@#$%^&*|\\\'\";:\/?]/gi; //eslint-disable-line
  if (specialStr.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//문자열에 한글, 영문만 입력 가능
export function name_pattern (asValue) {
  let nameRegExp  = /^[가-힣a-zA-Z]+$/;
  if (nameRegExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//문자열에 숫자가 있는 경우
export function include_num (asValue) {
  let numRegExp  = /^[0-9]+$/
  if (numRegExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//접속자 IP 주소 가져오기
export const getIPData = async (varInputs,setInputs,sname) => {
  await axios.get("https://geolocation-db.com/json/").then((res) => {
    if(sname === '') {
      setInputs(res.data.IPv4);
    } else {
      setInputs({ ...varInputs, [sname]: res.data.IPv4 });
    }
  });
};

//이메일중복검사 버튼 표시 결정
export const CheckDuplicationObject = (objID,bmode) => {
  //중복확인버튼 표시 유무
  const objBotton = document.getElementById(objID);
  console.log(objBotton);
  console.log(bmode);
  if(!bmode) {
    if(objBotton.classList.contains('hide')) objBotton.classList.remove('hide');
  } else {
    if(!objBotton.classList.contains('hide')) objBotton.classList.add('hide');
  }
}

//파일 input을 리셋
export const resetFileForm = (elFileForm) => {
  var orgParent = elFileForm.parentNode;
  var orgNext = elFileForm.nextSibling;

  var tmp = document.createElement('form');
  tmp.appendChild(elFileForm);

  tmp.reset();
  orgParent.insertBefore(elFileForm,orgNext);
}

//문자열 변환 —— 데이타베이스 저장
export const escapeHtml = (stext) => {
  if(isNull(stext)) return "";
  return stext.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
export const unescapeHtml = (stext) => {
  if(isNull(stext)) return "";
  return stext.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&#039;/g, "'");
};

//파일 크기 제한
export const  CheckLimitFileSize = (selFile,kbSize) => {
  const fileSize = selFile.size;
  const maxSize = kbSize * 1024;
  if(fileSize > maxSize) return false;
  else return true;
}

//br 처리
export const changeTextArea =(text) => {
  console.log(typeof text);
  var br_text = '';
  br_text = text.replaceAll(/(\n|\r\n)/g, "<br>");
  // br_text = text?.replace(/&lt;/g, '<');
  // br_text = text?.replace(/&gt;/g,'>');
  // br_text = text?.replace(/&nbsp;/g,' ');
  // br_text = text?.replace(/&amp;/g, '&');
  // br_text = text?.replace(/&quot;/g, '"');
  console.log(br_text);
  return br_text;
}

//문자열에 문자열을 구분자를 통해 추가
export const AddOptionToString = (sadd,stotal,sdiv) => {
  if(stotal === "") {
    stotal = sadd;
  } else {
    stotal = stotal + sdiv + sadd;
  }
  return stotal;
}
//문자열에 구분자로 구분된 문자항목중에서 지정한 문자항목 제외
export const ExceptOptionToString = (soption,stotal,sdiv) => {
  if(!stotal.includes(soption)) return stotal;  //옵션이 포함되어 있지 않으면
  if(!stotal.includes(sdiv)) return ""; //구분자없이 지정 옵션만 있으면 
  let retString = "";
  const optionArray = stotal.split(sdiv);
  for(var i=0; i < optionArray.length; i++) {
    if(optionArray[i] !== soption) {
      retString = AddOptionToString(optionArray[i],retString,sdiv);
    }
  }
  return retString;
}

//타이머 - 표시
export const TimeFormat = (itime) => {
  const m = Math.floor(itime / 60).toString();
  let s = (itime % 60).toString();
  if (s.length === 1) s = `0${s}`;
  return `${m}:${s}`;
}
//평을 제곱미터로
export const ChangeToSquareMeter = (pyong,ino) => {
  const sm = pyong * 3.3058;
  const retvalue = sm.toFixed(ino);
  return retvalue;
}

//ALIGO SMS 발송
export const sendMessageToMobile = async(mem_mobile,certCode) => {
  const receiverPhone = ChangeMobileFormat(mem_mobile);
  const message = `[마마몽떼] 요청하신 본인인증코드입니다. : ${certCode}`;
  const sendData = {sender:"010-8345-3471",receiver:receiverPhone,msg:message,msg_type:'SMS'};
  console.log(sendData);
  await axios.post(`${process.env.REACT_APP_HOST}/_send_message`, sendData).then((res) => {
    console.log(res.data);
    alert(res.data.message);
  });
}
//NULL 값의 경우 처리 --- 데이타베이스 저장을 위해
export const MakeNullDateFields = function(sfield,sdate) {
  if(sdate === null || sdate === "") {
    return `${sfield}=NULL`;
  } else {
    return `${sfield}='${ChangeSearchingDateFormat(sdate,'-')}'`;
  }
}
//문자열을 배열로 저장
export const  MakeStringToArray = function(sString) {     
  let namesArray = [];  
  if(sString!==undefined && sString!==null && sString !== "" ){
    if(sString.includes(',')) {
      namesArray = sString.split(',');
    } else {
      namesArray[0] = sString;
    } 
  }
  return namesArray;
}
//배열을 문자열로 저장
export const MakeArrayToString = function(namesArray) {     
  let namesString = '';  
  if(namesArray?.length === 0) return namesString;
  if(namesArray?.length === 1){
    namesString = namesArray[0];
  } else {
    namesString = namesArray.join(',');
  }
  return namesString;
}

//input=file 초기화
export const SetEmptyInputFile = (fileBox) => {
  var agent = navigator.userAgent.toLowerCase();
  if ( (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || (agent.indexOf("msie") !== -1) ){
      // ie 일때 input[type=file] init.
      $(fileBox).replaceWith( $(fileBox).clone(true) );
      $("#parentCreateGroupFullName").val("");
  } else {
      //other browser 일때 input[type=file] init.
      $(fileBox).val("");
      $("#parentCreateGroupFullName").val("");
  }
}

/* 객체가 비어 있는지 확인 */
export function isEmptyString(sString) {
  if(sString === undefined || sString === null || sString === "") return false;
  else return true;
}

export const GetPhotoImage = (fileName,smode) => {
  if(fileName === null || fileName === "") fileName = `default_${smode}.png`;
  let fullfile = `${smode}/${fileName}`;
  return fullfile;
}

export const LoginAfterCheckLogin = (imode) => {
  if(imode === 0) {
    const mem_idx =  Number(localStorage.getItem("adminIdx"));
    const loginAdmin = localStorage.getItem("adminLoginState");
    if(isNull(loginAdmin) || Number(loginAdmin) === 0 || mem_idx === 0) {
      window.location.href = "/LoginAdmin";
    }
  } else if(imode === 1) {
    const mem_idx =  Number(localStorage.getItem("mem_idx"));
    const loginUser = localStorage.getItem("userLoginState");
    //console.log(isNull(loginUser),Number(loginUser),mem_idx);
    if(isNull(loginUser) || Number(loginUser) === 0 || mem_idx === 0) {
      window.location.href = "/Parents/Login";
    }
  } else if(imode === 2) {
    const branch_idx =  Number(localStorage.getItem("branch_idx"));
    const loginBranch = localStorage.getItem("branchLoginState");
    if(isNull(loginBranch) || Number(loginBranch) === 0 || branch_idx === 0) {
      window.location.href = "/Branch/Login";
    }
  }
}

//관리자 체크박스 선택 관련
//체크박스 초기화
export const clearCheckedLists = (bmode) => {
  const checkBoxes = document.querySelectorAll('.del-item');
  for(var i=0; i < checkBoxes?.length; i++) {
    checkBoxes[i].checked = bmode;
  }
  const checkAllBoxes = document.getElementById('deleteItems');
  checkAllBoxes.checked = bmode;
}

export const getExtensionFromFileName = (filename) => {
  if(filename === undefined || filename === null || filename === "") return '';
  var _fileLen = filename?.length;
  var _lastDot = filename.lastIndexOf('.');
  var _fileExt = filename.substring(_lastDot, _fileLen).toLowerCase();
  return _fileExt;
}

export const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest  }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <><input type="checkbox" ref={resolvedRef} {...rest} /></>
    )
  }
)
export const IndeterminateRadiobox = React.forwardRef(
  ({ indeterminate, ...rest  }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <><input type="radio" ref={resolvedRef} {...rest} /></>
    )
  }
)
export function replaceAll(string, search, replace) {
  if(isNull(string)) return "";
  //console.log(string,search,replace);
  return string.split(search).join(replace);
}

//원생의 센터 유치상태
export function GetChildrenState(istate) {
  let stateString = "재원";
  if(istate === 0) stateString = "퇴원";
  return stateString;
}

//원생의 클래스 등록상태에 따른 class
export function GetClassStatus(cstatus) {
  let sclass = "";
  switch (cstatus) {
    default:
    case 0: sclass = "st01"; break;
    case 1: sclass = "st02"; break;
    case 2: sclass = ""; break;
    case 3: sclass = "st03"; break;
  }
  return sclass;
}
export function GetClassChildrenStatus(cstatus) {
  let sclass = "";
  let sString = "";
  switch (cstatus) {
    default:
    case -1: sclass = "display-state st01"; sString="미결제"; break;
    case 1: sclass = "display-state st02"; sString="대기"; break;
    case 2: sclass = "display-state st03"; sString="출석"; break;
    case 3: sclass = "display-state st04"; sString="결석"; break;
  }
  return <div className={sclass}>{sString}</div>;
}

//구매상태
export function GetPaymentStatus(pstatus) {
  let sstatus = "";
  switch (pstatus) {
    default:
    case 0: sstatus = "종료/결제취소"; break;
    case 1: sstatus = "미결제"; break;
    case 2: sstatus = "결제완료"; break;
    case 3: sstatus = "정산완료"; break;
    case 4: sstatus = "환불요청"; break;
    case 5: sstatus = "환불완료"; break;
    case -1: sstatus = "취소"; break;
    case -2: sstatus = "파기"; break;
  }
  return sstatus;
}
//구매상태
export function GetAdminPaymentStatus(pstatus) {
  let sstatus = "";
  if(isNull(pstatus)) return "미결제";
  switch (pstatus) {
    default:
    case 0: sstatus = "종료"; break;
    case 1: sstatus = "결제대기중"; break;
    case 2: sstatus = "결제완료"; break;
    case 3: sstatus = "정산완료"; break;
    case 4: sstatus = "환불요청"; break;
    case 5: sstatus = "환불완료"; break;
    case -1: sstatus = "결제취소"; break;
    case -2: sstatus = "파기"; break;
  }
  return sstatus;
}
//구매상태 - className
export function GetPaymentClassStatus(pstatus) {
  let sstatus = "";
  switch (pstatus) {
    default:
    case 0: sstatus = "pay-state03"; break;
    case 1: sstatus = "pay-state02"; break;
    case 2: sstatus = "pay-state01"; break;
    case 3: sstatus = "pay-state03"; break;
    case 4: sstatus = "pay-state03"; break;
    case 5: sstatus = "pay-state03"; break;
    case -1: sstatus = "pay-state02"; break;
    case -2: sstatus = "pay-state02"; break;
  }
  return sstatus;
}
export const GetPaymentDateStatus = (istatus) => {
  let dateTitle = "";
  switch(istatus) {
    default:
    case 1: dateTitle = "구매신청일자"; break;
    case 2: 
    case 3: dateTitle = "결제일자"; break;
    case 4: dateTitle = "발송일자"; break;
    case 5: dateTitle = "교환신청일자"; break;
    case 6: dateTitle = "반품신청일자"; break;
    case 7: dateTitle = "환급일자"; break;
  }
  return dateTitle;
}
export const GetDateForPaymentStatus = (sobj) => {
  let sdate = "";
  switch(sobj.pp_status) {
    default:
    case 1: sdate = sobj.pp_rdate; break;
    case 2: 
    case 3: sdate = sobj.pp_pdate; break;
    case 4: sdate = sobj.pp_sdate; break;
    case 5: sdate = sobj.pp_exdate; break;
    case 6: sdate = sobj.pp_redate; break;
    case 7: sdate = sobj.pp_rtdate; break;
  }
  return ChangeDateStringOnlyDate(sdate);
}

//1개월 후
export const GetNextMonth = (sdatetime) => {
  if(isNull(sdatetime)) return "";
  let sdate = new Date(sdatetime);
  sdate.setDate(sdate.getDate() + 30);
  const kdate = ChangeDateFormatToKorean(sdate);
  return kdate;
}
//요일
export function GetWeekendDay(sdate) {
  const week = ['일', '월', '화', '수', '목', '금', '토'];
  const dayOfWeek = week[sdate.getDay()];
  return dayOfWeek;
}
//매월 1일
export function FirstDayForMonth(sdate) {
  const firstDay = new Date(sdate.getFullYear(), sdate.getMonth(), 1);
  return firstDay;
}
//매월 마지막 일자
export function LastDayForMonth(sdate) {
  const lastDay = new Date(sdate.getFullYear(), sdate.getMonth() + 1, 0);
  return lastDay;
}
//해당월의 날짜수
export function GetDaysInThisMonth(sdate) {
  const mdays = new Date(sdate.getFullYear(),sdate.getMonth() + 1, 0).getDate();
  return mdays;
}
//해당월의 달력만들기
export function GetMonthCalendar(smonth) {
  //시작일
  const nmonth = smonth.replace('.','-')+'-01';     //1일
  const stdate = new Date(nmonth);         //첫째날
  const iweekday  = stdate.getDay();

  //마지막일
  const eddate = new Date(stdate.getFullYear(),stdate.getMonth() + 1, 0);
  const dmax = eddate.getDate(); //말일
  const eweekday  = eddate.getDay();

  //달력만들기
  let weekArray = [];
  let weekdateArray = [];
  let sobj = {};

  //1일전의 빈공간 날짜
  for(var b=0;b < iweekday; b++) {
    let sobj = {date:0,week:'',select:0};
    weekdateArray.push(sobj);
  }
  //1일부터 말일까지
  for(var i=0; i < dmax; i++) {
    const iday = stdate.getDay();  //0~6
    let sweek = GetWeekendDay(stdate);  //요일 : 일~토
    sobj = {date:i+1,week:sweek,select:0};
    weekdateArray.push(sobj);
    stdate.setDate(stdate.getDate() + 1);
    if(iday === 6) {  //토요일이면
      weekArray.push(weekdateArray);
      weekdateArray = [];
    }
  }
  //말일 이후의 요일
  if(eweekday < 6){
    for(var a=eweekday+1; a < 7; a++) {
      sobj = {date:0,week:'',select:0};
      weekdateArray.push(sobj);
    }
    weekArray.push(weekdateArray);
  }
  return weekArray;
}
//해당일자가 존재하는 주일배열의 번호를 반환
export function GetWeekIndex(iday,weeksArray) {
  let iweekIndex = 0;
  for(var i=0; i < weeksArray.length; i++) {
    let weekArray = weeksArray[i];
    for(var j=0; j < 7; j++) {
      if(weekArray[j].date === iday) {
        iweekIndex = i;
        break;
      }
    }
  }
  return iweekIndex;
}
//해당일자가 존재하는 주일배열의 번호를 반환
export function SetSelectedDateState(iday,weeksArray) {
  for(var i=0; i < weeksArray.length; i++) {
    let weekArray = weeksArray[i];
    for(var j=0; j < 7; j++) {
      if(weekArray[j].date === iday) {
        weeksArray[i][j].select = 1;
      } else {
        weeksArray[i][j].select = 0;
      }
    }
  }
  return weeksArray;
}
//해당일자 기준으로 1주일 달력만들기
export function GetWeekCalendar(dbdate) {
  let sdate = new Date(dbdate);
  const dmax = GetDaysInThisMonth(sdate); //말일
  const cdate = sdate.getDate();  //일자
  
  let idate = cdate - 3;  //시작일자
  //if(idate <= 0) idate = 1; //-이면 

  sdate.setDate(idate);
  console.log(sdate);
  let days = [];
  for(var i=0; i < 7; i++) {
    let ddate = idate+i;
    let sobj = {date:0,week:'',select:0};
    if(ddate > 0 && ddate <= dmax) {
      let iselect = 0;
      if(cdate === ddate) iselect = 1;
      let sweek = GetWeekendDay(sdate);
      sobj = {date:ddate,week:sweek,select:iselect};
      sdate.setDate(sdate.getDate() + 1);
    }
    days.push(sobj);
  }
  return days;
}
//swiper에서 여러개 동시에 보여줄 경우 시작위치
export function GetInitializeSwipers(dbdate) {
  const sdate = new Date(dbdate);
  let idate = sdate.getDate() - 4;
  if(idate <= 0) idate = 0;
  return idate;
}
//시간을 시각과 분으로
export function SetTimeArray(stime) {
  let timeArray = ['00','00'];
  if(isNull(stime)) return timeArray;
  const stimes = stime.split(':');
  const shour = ('0' + stimes[0]).slice(-2);
  const sminute = ('0' + stimes[1]).slice(-2);
  timeArray = [shour,sminute];
  return timeArray;
}


export function GetBooleanString(ivalue) {
  if(ivalue === 0) return "부";
  else return "여";
}

export const ExecuteLogin = (members) => {
  localStorage.setItem("mem_idx", members.mem_idx);
  localStorage.setItem("mem_id", members.mem_id);
  localStorage.setItem("mem_name", members.mem_name);
  localStorage.setItem("mem_branch_idx", members.bh_idx);
  localStorage.setItem("mem_branch_company", members.bh_company);
  localStorage.setItem("mem_branch_member_id", members.bh_member_id);
  localStorage.setItem("mem_branch_merchant_id", members.bh_merchant_id);
  //localStorage.setItem("mem_sns_login", members.mem_sns_login);
  //localStorage.setItem("mem_nickname", members.mem_name);
  localStorage.setItem("mem_mobile", members.mem_mobile);
  //localStorage.setItem("mem_email", members.mem_email);
  //localStorage.setItem("mem_balance", members.ma_balance);
  //localStorage.setItem("mem_coupons", members.ma_coupons);
  //localStorage.setItem("mem_mode", members.mem_mode);
  //localStorage.setItem("mem_gender", members.mem_gender);
  //localStorage.setItem("mem_image", members.mem_image);
  //localStorage.setItem("mem_photo", members.mem_photo);
  localStorage.setItem("mem_status", members.mem_status);
  localStorage.setItem("userLoginState", 1);
  localStorage.setItem('childrenIndex',0);
  return true;
}

export const ExecuteLogout = () => {
  localStorage.removeItem("mem_idx");
  //localStorage.removeItem("mem_nickname");
  localStorage.removeItem("mem_name");
  localStorage.removeItem("mem_mobile");
  localStorage.removeItem("mem_branch_idx");
  localStorage.removeItem("mem_branch_company");
  localStorage.removeItem("mem_branch_member_id");
  localStorage.removeItem("mem_branch_merchant_id");
  //localStorage.removeItem("mem_mode");
  //localStorage.removeItem("mem_email");
  //localStorage.removeItem("mem_balance");
  //localStorage.removeItem("mem_coupons");
  //localStorage.removeItem("mem_image");
  //localStorage.removeItem("mem_photo");
  localStorage.removeItem("autoLogin");
  localStorage.removeItem("mem_status");
  localStorage.removeItem("userLoginState");
  localStorage.removeItem('childrenIndex');
  return true;
}

export const ExecuteLoginBranch = (branchs,autoLogin) => {
  localStorage.setItem("branch_idx", branchs.bh_idx);
  localStorage.setItem("branch_id", branchs.bh_id);
  localStorage.setItem("branch_company", branchs.bh_company);
  localStorage.setItem("branch_name", branchs.bh_name);
  localStorage.setItem("branch_mobile", branchs.bh_mobile);
  localStorage.setItem("branch_email", branchs.bh_email);
  localStorage.setItem("branch_image", branchs.bh_image);
  localStorage.setItem("branch_photo", branchs.bh_photo);
  localStorage.setItem("branch_status", branchs.bh_status);
  localStorage.setItem("branch_member_id", branchs.bh_member_id);
  localStorage.setItem("branch_merchant_id", branchs.bh_merchant_id);
  localStorage.setItem("branch_bizcode", branchs.bh_biz_code.replace(/-/g,''));
  localStorage.setItem("branchLoginState", 1);
  return true;
}

export const ExecuteLogoutBranch = () => {
  localStorage.removeItem("branch_idx");
  localStorage.removeItem("branch_id");
  localStorage.removeItem("branch_company");
  localStorage.removeItem("branch_name");
  localStorage.removeItem("branch_mobile");
  localStorage.removeItem("branch_email");
  localStorage.removeItem("branch_image");
  localStorage.removeItem("branch_email");
  localStorage.removeItem("branch_photo");
  localStorage.removeItem("branch_member_id");
  localStorage.removeItem("branch_merchant_id");
  localStorage.removeItem("branch_bizcode");
  localStorage.removeItem("branchLoginState");
  localStorage.removeItem("branch_autoLogin");
  return true;
}

//영양제 팝업창 표시를 위한 설정
export const SetBasePageStatus = (bmode) => {
  const headerBox = document.getElementById('header');
  const menuBox = document.getElementById('gnb-menu-wrap');
  //console.log(headerBox);
  if(bmode) {
    if(!isNull(headerBox)) headerBox.setAttribute('style','z-index:1;');
    if(!isNull(menuBox)) menuBox.setAttribute('style','z-index:0;');
  } else {
    if(!isNull(headerBox)) headerBox.setAttribute('style','z-index:110;position:sticky;top:0px;background-color:rgb(255, 255, 255);');
    if(!isNull(menuBox)) menuBox.setAttribute('style','z-index:8000;');
  }
}

//앱에서 받은 토큰값 서버에 저장
export const UpdateTokenDevice = async(mem_idx,device) => {
  const sendData = {mem_idx:mem_idx,mem_device:device};
  console.log(sendData);
  await axios.post(`${process.env.REACT_APP_HOST}/_update_token_member`,sendData).then((res) => {
    return false;
  });
}

//문자열에서 오른쪽기준 문자수만큼 문자열 반환
export const GetStringForRight = (stext,inum) => {
  if (isNull(stext)) return '';
  const ilen = stext.length;
  const svalue = stext.substr(ilen-inum,inum);
  return svalue;
}

/* //기간에 해당하는 주단위 날짜 배결 생성
export const MakeTotalStudyWeeks = (sdate,edate) => {
  let s_date = new Date(sdate);
  let e_date = new Date(edate);
  const s_day = s_date.getDay();
  const e_day = e_date.getDay();

  let e_saturday = e_date.setDate(e_date.getDate() + (6 - e_day));
  let last_day = ChangeDateFormat(e_saturday);

  let s_sunday = s_date.setDate(s_date.getDate() - s_day);
  let s_saturday = new Date(s_sunday);
  s_saturday.setDate(s_saturday.getDate() + 6);

  let weeks = [];
  var i=0;
  do {
    s_sunday.setDate(s_sunday.getDate() + (7*i)); 
    s_saturday.setDate(s_saturday.getDate() + (7*i)); 

    let st_day = ChangeDateFormat(s_sunday);
    let ed_day = ChangeDateFormat(s_saturday);

    let sobj = {sdate:st_day,edate:ed_day};
    weeks.push(sobj);
    i++;
    if(ed_day === last_day) break;
  } while(true);

  return weeks;
}
//오늘 주 찾기
export const FindStudyWeekIndex = (weeks) => {
  let today = new Date();
  for(let i = 0; i < weeks.length; i++) {
    let sdate = new Date(weeks[i].sdate);
    let edate = new Date(weeks[i].edate);
    if(today >= sdate && today <= edate) return i;
  }
  return -1;
} */

//학습차수별 원생정보
export const GetChildrenInfoForList = (childrens,imode) => {
  const cname = childrens.ch_name;
  const cmonth = PassedMonthsCode(childrens.ch_birthday);
  let retString = `${cname} (${cmonth})`;
  if(imode >= 0) {
    const cnt = childrens.rcount;
    const tcnt = childrens.tstudys;
  
    if(imode === 1) {
      const rdate = childrens.csc_rdate;
      const cdate = new Date(rdate);
      const today = new Date();
      if(today >= cdate) {
        const status = childrens.csc_status===2?"출석"
                      :childrens.csc_status===3?"결석"
                      :childrens.csc_status===-1?"추천"
                      :childrens.csc_status===1?"대기":"종료";
        const sdate = GetSimpleDateTimeFromJDateTime(rdate);
        retString += `_${status} (${cnt}/${tcnt})`;
        if(childrens.csc_status===2) retString += ' ' + sdate
      }
    } else {
      retString += ` (${cnt}/${tcnt})`;
    }
  }
  return retString;
}
//수업에 대한 원생의 상태 - 원생추가 페이지
export const GetChildrenStatusForList = (childrens,imode) => {
  let retString = "";
  if(imode === 0) {
    if(childrens.csc_mode === 0) {  //정규
      if(childrens.csc_status===-1) retString = " - 예약중";
      else if(childrens.csc_status===1) retString = " - 수업 대기중";
    } else {
      if(childrens.csc_status===-1) retString = " - 학부모 확정 대기중";
      else if(childrens.csc_status===1) retString = " - 확정 수업 대기중";
    }
  } else {
    retString = "- 미등록";
  }
  return retString;
}

export const GetStudyTime = (sobj) => {
  const sdate = ChangeSimpleDateString(sobj.cs_date);
  const times = `${sobj.cs_hour}:${sobj.cs_minute}`;
  return `${sdate} ${times}`;
}

export const GetChildrenStudyStatus = (childrens) => {
  const rdate = childrens.csc_rdate;
  const cdate = new Date(rdate);
  const today = new Date();
  let istatus = 0;
  if(today <= cdate) {
    if(childrens.csc_status === 1) istatus = 1;
  }
  return istatus;
}

export const ToggleDarkBackground = (bmode) => {
  if(bmode) $(".layer-bg").fadeIn("1500");
  else $(".layer-bg").fadeOut("1500");
}

//수업차수 배열 만들기
export const MakeClassStudyList = (istudys) => {
  let newList = [];
  for(var i=1;i<=istudys;i++) {
    newList.push(i);
  }
  return newList;
}

//결제일자
export const GetPaymentDate = (payments) => {
  let sdate = "";
  if(payments.ph_status === 1) sdate = payments.ph_rdate;
  else sdate = payments.ph_pdate;
  return GetDateTimeFromJDateTime(sdate);
}

export const DisplayOptionString = (sobj) => {
  let terms = "";
  if(sobj.terms === 0) {
    terms = "전체";
  } else if(sobj.terms === 1) {
    terms = "[일별]";
    terms += " " + ChangeSimpleDateString(sobj.sdate);
  } else {
    if(sobj.terms === 2) terms = "[주간]";
    else if(sobj.terms === 3) terms = "[월간]";
    else if(sobj.terms === 4) terms = "[연간]";
    terms += " " + ChangeSimpleDateString(sobj.sdate)+ " ~ " + ChangeSimpleDateString(sobj.edate);
  }
  return terms; 
}

//교재명
export const GetTextBookName = (sobj) => {
  if(isObjEmpty(sobj)) return "";
  let textbook = "감각/기하";
  if(sobj.cl_fly_mode===1) textbook = "수/연산";
  if(!isNull(sobj.vt_name)) textbook += sobj.vt_name.substr(0,1);
  if(sobj.cs_index > 0) textbook += '0' + sobj.cs_index.toString().slice(-2);
  return textbook;
}
//수료증발급
export const GetCertificateStatus = (issues,vl_idx) => {
  const issueList = issues.filter(el=>el.vl_idx === vl_idx);
  if(issueList.length === 0) {
    return "";
  } else {
    const issueData = issueList[0];
    if(issueData.ce_status === 1) return "[발급 대기]";
    else return "[발급 완료]";
  }
}
export const GetCertificateClassStatus = (issues,vl_idx) => {
  const issueList = issues.filter(el=>el.vl_idx === vl_idx);
  if(issueList.length === 0) return false;
  const issueData = issueList[0];
  if(issueData.ce_status === 2) return true
  else return false;
}

//관리자 - 원생 수업 출석 현환
export const GetAdminAttendanceStatus = (istate) => {
  let statusString = "-";
  if(istate === 1) statusString = "-";
  else if(istate === 2) statusString = "출석";
  else if(istate === 3) statusString = "결석";
  else if(istate === -1) statusString = "추천대기중";
  else statusString = "-";
  return statusString;
}

//부모/원생 수업 출석 현환
export const GetAdminAttendanceStatusString = (sobj) => {
  let istate = 1;
  if(!isNull(sobj.csc_status)) istate = sobj.csc_status;
  console.log(istate);
  let statusString = "수강없음";
  if(istate === 1 || istate === -1) statusString = "예정 : ";
  else if(istate === 2) statusString = "출석 : ";
  else if(istate === 3) statusString = "결석 : ";

  if(istate === 2) statusString += GetSimpleDateTimeFromJDateTime(sobj.csc_rdate);
  else statusString += ChangeSimpleDateString(sobj.cs_date) + ' ' + sobj.cs_hour + ':' + sobj.cs_minute;
  return statusString;
}

//원생선택유무
export const CheckIncludesIndex = (sList,csc_idx) => {
  const findIndex = sList.findIndex(el=>el.csc_idx === csc_idx);
  if(findIndex === -1) return false;
  else return true;
}
//월 단위조정
export const ResetMonthString = (smonth) => {
  if(smonth < 10) smonth = '0' + smonth;
  return smonth;
}

//엑셀파일 생성
export const MakeExcelFileForDownload = (columnList,dataArray,fileName) => {
  //표시할  Header(제목부)과 accessor(필드명) 배열 생성
  let jline = 0;
  let cols = [], rows = [];
  for(var im=0; im < columnList.length-1; im++) {
    cols.push(columnList[jline].Header);
    rows.push(columnList[jline].accessor);
    jline++;
  }
  //엑셀 내용 생성
  let excelList = [];
  for(var i=0; i < dataArray.length; i++) {
    var lineObj = dataArray[i];
    var newExcelObj = {};
    for(var j=0; j < jline; j++) {
      newExcelObj[cols[j]] = lineObj[rows[j]];
    }
    excelList.push(newExcelObj);
  }
  //엑셀파일로 저장
  const ws = utils.json_to_sheet(excelList);
  const wb = utils.book_new();
  utils.book_append_sheet(wb,ws,fileName);
  writeFileXLSX(wb,`${fileName}관리.xlsx`);
}
//EXCEL 버튼 감추기
export const CloseExcelPopup = () => {
  const popupWin = document.querySelector('.excel-buttons');
  if(!popupWin.classList.contains('hide')) popupWin.classList.add('hide');
}

//파일 다운로드 <-- 서버로부터
export const DownloadFile = (fileUrl,realFile,imode) => {
  const mobileType = navigator.userAgent.toLowerCase();
  (async () => {
    const data = await fetch(fileUrl);
    const blob = await data.blob();
    const reader = new FileReader();
    reader.onload = () => {
        const base64data = reader.result;
        console.log(base64data);
        if (mobileType.indexOf('android') > -1) {
          if(imode === 1) {
            if(window.mamamonteP){
              window.mamamonteP.downloadBase64File(base64data, realFile, 'application/octet-stream');
              alert('다운로드가 완료되었습니다.');
            }
          } else {
            if(window.mamamonte){
              window.mamamonte.downloadBase64File(base64data, realFile, 'application/octet-stream');
              alert('다운로드가 완료되었습니다.');
            }
          }
        } else {
          const downloadUrl = window.URL.createObjectURL(new Blob([base64data]));
          console.log(downloadUrl);
          const a = document.createElement('a');
          a.setAttribute('style','display:none');
          a.href = downloadUrl;
          a.download = realFile;  //실제파일명
          a.click();
          window.URL.revokeObjectURL(downloadUrl);
          alert('다운로드가 완료되었습니다.');
        }
    }
    reader.readAsDataURL(blob);
  })();
};

//파일 다운로드 - 이미지 파일 <-- 서버로부터
export const DownloadImageFile = async(fileUrl,realFile) => {
  const a = document.createElement('a');
  a.setAttribute('style','display:none');
  a.href = await toDataURL(fileUrl);
  a.download = realFile;  //실제파일명
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  alert('다운로드가 완료되었습니다.');
};
export const toDataURL = (fileUrl) => {
  return fetch(fileUrl)
  .then((response) => {
    return response.blob();
  })
  .then((blob) => {
    return URL.createObjectURL(blob);
  });
};


//글자넣기
export const DrawingText = (contents,info) => {
  contents.beginPath();
  contents.font = info.fsize+'px Arial';
  contents.textAlign = info.textAlign;
  //ctx.textBaseline = textBaseline;
  contents.fillStyle = 'black';
  contents.fillText(info.text, info.x, info.y);
  contents.stroke();
}

//수업형태
export const GetClassStudyMode = (classes) => {
  let retMode = "";
  if(classes.cl_mode === 2 || classes.clc_mode === 1) retMode = "보강수업";
  else if(classes.cl_mode === 0 || classes.clc_mode === 2) retMode = "참여수업";
  else retMode = "정규수업";
  return retMode; 
}

//교재명 생성
export const GetBookName = (vt_name,vts_idx) => {
  let bookname = "";
  if(!isNull(vt_name)) bookname = `${vt_name}-${AddZeroFillForNumber(vts_idx,2)}`;
  return bookname;
}

//슷자를 순서로
export const ChangeNumberFormat = (inum) => {
  let snum = "";
  switch(inum) {
    case 1: snum = "1st"; break;
    case 2: snum = "2nd"; break;
    case 3: snum = "3rd"; break;
    default: snum = inum+"th"; break;
  }
  return snum;
}

//로컬스토리지에 저장된 값 읽기
export const GetLocalStorageValue = (soption,itype) => {
  if(itype === 0) {
    let retValue = 0;
    if(!isNull(localStorage.getItem(soption))) retValue = Number(localStorage.getItem(soption));
    return retValue;
  } else {
    let retString = "";
    if(!isNull(localStorage.getItem(soption))) retString = localStorage.getItem(soption);
    return retString;
  }
}